import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=4bd2420c&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=4bd2420c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2420c",
  null
  
)

export default component.exports